/*
 * pn-sticky-cart.js — Polente Natural · 31.08.2026
 * ---------------------------------------------------------------------------
 * Yapışkan sepet çubuğunun tetikleyicisini düzeltir.
 *
 * SORUN
 * Temanın <animate-sticky> öğesi çubuğu "kaydırma > kendi offsetTop'u"
 * koşuluyla açıyor. O öğe ürün bölümünün EN SONUNDA durduğu için eşik,
 * açıklama metni ve üç açılır sekme dahil bütün bölümün yüksekliği kadar
 * oluyor — çubuk, kullanıcı gerçek "Sepete Ekle" düğmesini çoktan geçtikten
 * sonra açılıyor. Yani işe yarayacağı anı kaçırıyor.
 *
 * ÇÖZÜM
 * Bu dosya tema dosyalarını değiştirmez. Mevcut <animate-sticky> öğesini
 * bulur, onun kaydırma davranışını etkisiz hale getirir (örnek üzerindeki
 * reveal/reset metotlarını gölgeleyerek) ve çubuğu bir IntersectionObserver
 * ile doğrudan sayfa içindeki ATC düğmesine bağlar.
 *
 * Yan etkiler:
 *  - Çubuk açıkken <body>'ye .sticky-cart-open eklenir (alt menü ve sohbet
 *    balonuyla çakışmayı CSS bu sınıf üzerinden çözer).
 *  - Çubuktaki varyant seçicinin telefonda gizlenmesini sağlayan small-hide
 *    sınıfı kaldırılır.
 *  - Gönderim anında ana formdaki seçili varyant çubuğun formuna kopyalanır.
 * ---------------------------------------------------------------------------
 */
(function () {
  'use strict';

  /* Sayfa içindeki gerçek ATC düğmesi. Çubuğun kendi düğmesi de
     .product-form__submit taşıdığı için seçici button--full-width ile
     daraltılmıştır. */
  var ATC_SELECTOR = '.product-form__submit.button--full-width';
  var WRAPPER_SELECTOR = '.sticky-cart-wrapper';
  var OPEN_CLASS = 'sticky-cart-open';

  function init() {
    var wrapper = document.querySelector(WRAPPER_SELECTOR);
    if (!wrapper) return; /* bu sayfada yapışkan çubuk yok */

    neutralizeOldTrigger(wrapper);
    showVariantsOnMobile(wrapper);
    syncVariantOnSubmit(wrapper);
    bindToAddToCart(wrapper);
  }

  /* --- 1. Eski tetikleyiciyi sustur ------------------------------------- */
  /* AnimateSticky.onScroll, this.reveal / this.reset çağırıyor. Örnek
     üzerine aynı adla boş fonksiyon yazınca prototip metodu gölgelenir;
     kaydırma dinleyicisi çalışmaya devam eder ama hiçbir şey yapmaz.
     Tema ileride bu metotları yeniden adlandırırsa gölgeleme etkisiz kalır —
     o durumda iki tetikleyici birlikte çalışır ve çubuk yine ATC'de açılır,
     sadece daha geç kapanır. Bozulma değil, kabul edilebilir bir gerileme. */
  function neutralizeOldTrigger(wrapper) {
    /* Koşulsuz atanır: örnek özelliği, öğe henüz "upgrade" olmamış olsa bile
       prototip metodunu gölgeler ve upgrade sonrası da yerinde kalır. */
    wrapper.reveal = function () {};
    wrapper.reset = function () {};
    wrapper.removeAttribute('animate');
  }

  /* --- 2. Telefonda varyant seçiciyi göster ----------------------------- */
  function showVariantsOnMobile(wrapper) {
    var nodes = wrapper.querySelectorAll('variant-selects.small-hide');
    for (var i = 0; i < nodes.length; i++) {
      nodes[i].classList.remove('small-hide');
    }
    wrapper.classList.add('pn-sticky-cart--variants');
  }

  /* --- 3. Doğru varyantın sepete düştüğünden emin ol -------------------- */
  /* Çubuğun formundaki gizli id alanı kaynakta disabled geliyor. Gönderimden
     hemen önce, sayfa içindeki ana formda seçili olan varyantı kopyalarız —
     kullanıcı yukarıda hangi boyutu seçtiyse sepete o düşer. */
  function syncVariantOnSubmit(wrapper) {
    var stickyForm = wrapper.querySelector('form[action*="/cart/add"]');
    if (!stickyForm) return;

    stickyForm.addEventListener(
      'submit',
      function () {
        var stickyInput = stickyForm.querySelector('input[name="id"]');
        if (!stickyInput) return;

        var forms = document.querySelectorAll('form[action*="/cart/add"]');
        for (var i = 0; i < forms.length; i++) {
          if (wrapper.contains(forms[i])) continue; /* çubuğun kendi formu */
          var mainInput = forms[i].querySelector('input[name="id"]');
          if (mainInput && mainInput.value) {
            stickyInput.value = mainInput.value;
            stickyInput.disabled = false;
            return;
          }
        }
      },
      true /* capture: tema kendi submit işleyicisinden önce çalışsın */
    );
  }

  /* --- 4. Çubuğu ATC düğmesine bağla ------------------------------------ */
  function bindToAddToCart(wrapper) {
    var target = document.querySelector(ATC_SELECTOR);

    if (!target || typeof IntersectionObserver === 'undefined') {
      /* Hedef yoksa çubuğu hiç açma — yanlış anda açmaktansa hiç açmamak
         daha iyi. Tema güncellemesinde seçici değişirse konsolda görünsün. */
      if (!target && window.console) {
        console.warn('[pn-sticky-cart] ATC düğmesi bulunamadı:', ATC_SELECTOR);
      }
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        var entry = entries[0];
        /* Düğme yukarı kayıp ekrandan çıktıysa aç. Aşağıdan yaklaşırken
           (top > 0) açma — sayfa yüklenirken düğme henüz ekranın altındaysa
           çubuk görünmemeli. */
        var scrolledPast =
          !entry.isIntersecting && entry.boundingClientRect.top < 0;

        if (scrolledPast) {
          wrapper.setAttribute('animate', '');
        } else {
          wrapper.removeAttribute('animate');
        }
        document.body.classList.toggle(OPEN_CLASS, scrolledPast);
      },
      { threshold: 0 }
    );

    observer.observe(target);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
